import { Controller } from "@hotwired/stimulus"

// Handles export buttons that submit forms but shouldn't leave the form disabled
// Usage: <button data-controller="export-button">Export</button>
export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.reenableForm.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("click", this.reenableForm.bind(this))
  }

  reenableForm() {
    setTimeout(() => {
      const form = this.element.closest("form")
      if (form) {
        form.querySelectorAll(":disabled").forEach(el => el.disabled = false)
      }
    }, 100)
  }
}
